import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth, homePath } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { ErrorBox, Field, Loading } from "@/components/common";

export default function ChangePassword() {
  const { user, setSession, logout } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (f.new_password.length < 8) return setErr("كلمة المرور الجديدة يجب أن تتكون من 8 أحرف على الأقل");
    if (f.new_password !== f.confirm) return setErr("تأكيد كلمة المرور غير مطابق");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      setSession(data.token, data.user);
      toast.success("تم تغيير كلمة المرور بنجاح");
      nav(homePath(data.user), { replace: true });
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={submit} className="k-card w-full max-w-md p-8 space-y-5" data-testid="change-password-form">
        <div className="flex items-center gap-3">
          <span className="rounded-xl bg-amber-50 p-3 text-[#B45309]"><KeyRound /></span>
          <div>
            <h1 className="text-2xl font-extrabold text-[#1A4D2E]">تغيير كلمة المرور</h1>
            {user.must_change_password && <p className="text-sm text-amber-700 font-bold" data-testid="must-change-notice">يجب تغيير كلمة المرور المؤقتة قبل المتابعة</p>}
          </div>
        </div>
        <Field label="كلمة المرور الحالية"><input type="password" className="k-input" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="current-password-input" required /></Field>
        <Field label="كلمة المرور الجديدة" hint="8 أحرف على الأقل"><input type="password" className="k-input" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="new-password-input" required /></Field>
        <Field label="تأكيد كلمة المرور الجديدة"><input type="password" className="k-input" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="confirm-password-input" required /></Field>
        <ErrorBox text={err} />
        <div className="flex gap-2">
          <button className="k-btn-primary flex-1" disabled={busy} data-testid="change-password-submit">{busy && <Loader2 className="w-4 h-4 animate-spin" />} حفظ</button>
          {user.must_change_password ? <button type="button" className="k-btn-outline" onClick={logout} data-testid="change-password-logout">خروج</button>
            : <button type="button" className="k-btn-outline" onClick={() => nav(-1)}>رجوع</button>}
        </div>
      </form>
    </div>
  );
}
